/* Memento Vento — scripts propios (sin librerías) */
(function () {
  'use strict';

  var reducir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Aparición al hacer scroll ---------- */
  var observador = null;
  function initReveal(raiz) {
    var els = (raiz || document).querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    if (reducir || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('mt-visible');
            observador.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observador.observe(el); });
  }

  /* ---------- Parallax suave del hero ---------- */
  function initParallax() {
    var visuales = document.querySelectorAll('[data-mt-parallax]');
    if (!visuales.length || reducir) return;
    var pendiente = false;
    function mover() {
      visuales.forEach(function (v) {
        var fuerza = parseFloat(v.getAttribute('data-mt-parallax')) || 0;
        var r = v.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        v.style.transform = 'translate3d(0,' + (r.top * fuerza * -0.01).toFixed(1) + 'px,0)';
      });
      pendiente = false;
    }
    window.addEventListener('scroll', function () {
      if (!pendiente) { pendiente = true; requestAnimationFrame(mover); }
    }, { passive: true });
    mover();
  }

  /* ---------- Página de producto ---------- */
  function formatearDinero(centimos, formato) {
    formato = formato || '${{amount}}';
    var valor = (centimos / 100);
    function num(n, dec, milesSep, decSep) {
      var partes = n.toFixed(dec).split('.');
      partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, milesSep);
      return partes.length > 1 ? partes[0] + decSep + partes[1] : partes[0];
    }
    return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, tipo) {
      switch (tipo) {
        case 'amount_no_decimals': return num(valor, 0, ',', '.');
        case 'amount_with_comma_separator': return num(valor, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(valor, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(valor, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return num(valor, 0, ' ', ',');
        case 'amount_with_space_separator': return num(valor, 2, ' ', ',');
        default: return num(valor, 2, ',', '.');
      }
    });
  }

  function initProducto() {
    document.querySelectorAll('[data-mt-pdp]').forEach(function (pdp) {
      if (pdp.getAttribute('data-mt-listo')) return;
      pdp.setAttribute('data-mt-listo', '1');
      /* Galería */
      var principal = pdp.querySelector('[data-mt-principal]');
      var minis = pdp.querySelectorAll('[data-mt-mini]');
      function mostrar(boton) {
        if (!principal || !boton) return;
        principal.style.opacity = '0';
        setTimeout(function () {
          principal.src = boton.getAttribute('data-src');
          principal.srcset = '';
          principal.alt = boton.getAttribute('data-alt') || '';
          principal.style.opacity = '1';
        }, 160);
        minis.forEach(function (m) { m.setAttribute('aria-current', m === boton ? 'true' : 'false'); });
      }
      minis.forEach(function (m) { m.addEventListener('click', function () { mostrar(m); }); });

      /* Cantidad */
      var cant = pdp.querySelector('[data-mt-cantidad]');
      pdp.querySelectorAll('[data-mt-cant-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!cant) return;
          var v = parseInt(cant.value, 10) || 1;
          v += parseInt(b.getAttribute('data-mt-cant-btn'), 10);
          cant.value = Math.max(1, v);
        });
      });

      /* Variantes */
      var datos = pdp.querySelector('[data-mt-variantes]');
      if (!datos) return;
      var variantes;
      try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
      var formato = pdp.getAttribute('data-money-format');
      var inputId = pdp.querySelector('input[name="id"]');
      var precio = pdp.querySelector('[data-mt-precio]');
      var tachado = pdp.querySelector('[data-mt-tachado]');
      var ahorro = pdp.querySelector('[data-mt-ahorro]');
      var boton = pdp.querySelector('[data-mt-boton]');
      var textoBoton = boton ? boton.querySelector('span') : null;
      var txtComprar = pdp.getAttribute('data-txt-comprar');
      var txtAgotado = pdp.getAttribute('data-txt-agotado');
      var txtNoDisp = pdp.getAttribute('data-txt-nodisp');
      var txtAhorra = pdp.getAttribute('data-txt-ahorra') || '';

      function actualizar() {
        var elegidas = [];
        pdp.querySelectorAll('[data-mt-opcion]').forEach(function (grupo) {
          var marcado = grupo.querySelector('input:checked');
          elegidas.push(marcado ? marcado.value : null);
        });
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === elegidas[i]; });
        });
        if (!v) {
          if (boton) boton.disabled = true;
          if (textoBoton) textoBoton.textContent = txtNoDisp;
          return;
        }
        if (inputId) inputId.value = v.id;
        if (precio) precio.textContent = formatearDinero(v.price, formato);
        var hayOferta = v.compare_at_price && v.compare_at_price > v.price;
        if (tachado) {
          tachado.textContent = hayOferta ? formatearDinero(v.compare_at_price, formato) : '';
          tachado.hidden = !hayOferta;
        }
        if (ahorro) {
          ahorro.hidden = !hayOferta;
          if (hayOferta) ahorro.textContent = txtAhorra + ' ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
        }
        if (boton) boton.disabled = !v.available;
        if (textoBoton) textoBoton.textContent = v.available ? txtComprar : txtAgotado;
        if (v.featured_image && principal) {
          var mini = pdp.querySelector('[data-mt-mini][data-media-id="' + (v.featured_media ? v.featured_media.id : '') + '"]');
          if (mini) mostrar(mini);
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      pdp.querySelectorAll('[data-mt-opcion] input').forEach(function (inp) {
        inp.addEventListener('change', actualizar);
      });
    });
  }

  function init() {
    initReveal();
    initParallax();
    initProducto();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Editor de Shopify: re-inicializar al añadir/editar secciones */
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    initProducto();
  });
})();
